// axios
import axios from "../axios/axios";
export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};

export const getResponseData = (url) => {
  return axios({
    url: url,
    method: "GET",
  });
};

export const getIndexRoute = (routes) => {
  return routes.find((route) => route.isIndex);
};

export const isCurrentLinkActive = (matchUrls, currentUrl) => {
  return matchUrls.includes(currentUrl);
};

export const getFirstCorrectImage = (images) => {
  return images.find((imageUrl) => isValidUrl(imageUrl)) || "";
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

export const convertToBase64 = async (blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onloadend = function () {
      resolve(reader.result.split(",")[1]);
    };
  });
};

export const isImageFile = (file) => {
  return file.type.includes("image/");
};

export const createElementAndAppendToBody = (elementId) => {
  const element = document.createElement("div");
  element.setAttribute("id", elementId);
  document.body.appendChild(element);
  return element;
};

export const scrollToSection = (sectionId, wrapperElement) => {
  const section = wrapperElement.querySelector(`#${sectionId}`);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
